var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"ordering-counterparty__radio"},[_c('input',{attrs:{"type":"radio"},domProps:{"checked":_vm.checked},on:{"change":function($event){return _vm.$emit('change', $event.target.value)}}}),_c('span',{staticClass:"ordering-counterparty__radio-state"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }